import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { Sidebar } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";
import { BottomNav } from "@/components/BottomNav";
import { ImpersonationBanner } from "@/components/ImpersonationBanner";
import { useAuth } from "@/contexts/AuthContext";

const TITLE_BY_PATH = [
    [/^\/$/, "Dashboard"],
    [/^\/customers\/new/, "New customer"],
    [/^\/customers\/[^/]+\/edit/, "Edit customer"],
    [/^\/customers\/[^/]+$/, "Customer"],
    [/^\/customers/, "Customers"],
    [/^\/vehicles\/new/, "New vehicle"],
    [/^\/vehicles\/[^/]+\/edit/, "Edit vehicle"],
    [/^\/vehicles\/[^/]+$/, "Vehicle"],
    [/^\/vehicles/, "Vehicles"],
    [/^\/appointments\/new/, "New appointment"],
    [/^\/appointments\/[^/]+/, "Appointment"],
    [/^\/appointments/, "Appointments"],
    [/^\/jobs\/new/, "New job"],
    [/^\/jobs\/[^/]+/, "Job card"],
    [/^\/jobs/, "Job cards"],
    [/^\/schedule/, "Schedule"],
    [/^\/bays/, "Bays"],
    [/^\/technicians/, "Technicians"],
    [/^\/notifications/, "Notifications"],
    [/^\/settings/, "Settings"],
    [/^\/users/, "Users"],
    [/^\/branches/, "Branches"],
    [/^\/audit/, "Audit log"],
    [/^\/login/, "Sign in"],
    [/^\/register/, "Create a workshop"],
];

function deriveTitle(path) {
    for (const [re, label] of TITLE_BY_PATH) {
        if (re.test(path)) return label;
    }
    return "Workshop OS";
}

export function AppShell({ children }) {
    const [open, setOpen] = useState(false);
    const { user } = useAuth();
    const isTechnician = user?.role === "technician";
    const loc = useLocation();
    useEffect(() => {
        document.title = `AutoBrix · ${deriveTitle(loc.pathname)}`;
    }, [loc.pathname]);

    return (
        <div className="flex min-h-screen flex-col bg-background">
            <ImpersonationBanner />
            <Topbar onToggleSidebar={() => setOpen(true)} />
            <div className="flex flex-1">
                {/* desktop sidebar (hide for technician) — independent scroll, sticky under topbar */}
                {!isTechnician && (
                    <div className="sticky top-14 hidden h-[calc(100vh-3.5rem)] shrink-0 overflow-y-auto md:block scrollbar-thin">
                        <Sidebar />
                    </div>
                )}
                {/* mobile drawer */}
                <Sheet open={open} onOpenChange={setOpen}>
                    <SheetContent side="left" className="w-72 p-0">
                        <Sidebar onNavigate={() => setOpen(false)} />
                    </SheetContent>
                </Sheet>

                <main className={`min-w-0 flex-1 px-4 py-6 md:px-8 ${isTechnician ? "pb-20" : ""}`}>
                    <div className="mx-auto min-w-0 max-w-7xl">{children}</div>
                </main>
            </div>
            {isTechnician && <BottomNav />}
        </div>
    );
}
